import { type Cache } from 'swr'
import { safeJsonParse } from '../safeJsonParse'
import { getStorageItem, setStorageItem, type STORAGE_EVENT } from '../storageHelper'

/**
 * 每個 provider 最多保留的快取筆數；
 * key 含請求參數（如 cart/calculate 帶整包 cart_values），不設上限會隨操作無限累積，
 * 拖慢載入時的 JSON.parse 與離開頁面時的寫入，並可能撐爆 storage quota。
 */
export const STORAGE_PROVIDER_MAX_ENTRIES = 20

/**
 * set 時把 key 移到最後，讓 Map 的順序代表最近使用順序，寫回 storage 時保留最新的幾筆
 */
class RecentlyUsedMap<K, V> extends Map<K, V> {
  override set(key: K, value: V) {
    super.delete(key)
    return super.set(key, value)
  }
}

export function createStorageProvider(key: string, type: STORAGE_EVENT): () => Cache {
  const storageProvider = () => {
    const map = new RecentlyUsedMap(safeJsonParse<[]>(getStorageItem(key, type) || '[]'))

    if (typeof window === 'undefined') return map as Cache

    window.addEventListener('beforeunload', () => {
      const appCache = Array.from(map.entries()).slice(-STORAGE_PROVIDER_MAX_ENTRIES)
      setStorageItem(key, appCache, type)
    })

    return map as Cache
  }

  return storageProvider
}
